import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import GoogleIO from './GoogleIO';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleIO />
  </React.StrictMode>
);
